import React from 'react'

function About() {
  return (
    <div className="container-xxl py-5" id="about">
    <div className="container">
      <div className="row g-5">
        <div
          className="col-lg-6 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ minHeight: 400 }}
        >
          <div className="position-relative h-100">
            <img
              className="img-fluid position-absolute w-100 h-100"
              src="assets/img/HomePage/mainimage.jpg"
              alt="Aboutus"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
          <h6 className="section-title bg-white text-start text-primary pe-3">
            About Us
          </h6>
          <h1 className="mb-4">
            Welcome to <span className="text-primary">Kothari Tour and Travels</span>
          </h1>
          <p className="mb-4">
          At Kothari Tour and Travels, we are dedicated to providing exceptional travel experiences. Whether you're planning a family vacation, a business trip, or a weekend getaway, we ensure a seamless and comfortable journey with our premium taxi and travel services.
          </p>
          <p className="mb-4">
          With years of experience in the travel industry, we pride ourselves on offering reliable, affordable, and customer-centric services. From city tours to outstation trips, airport transfers to group travel, we cater to all your travel needs with professionalism and care.

          </p>
          <div className="row gy-2 gx-4 mb-4">
            <div className="col-sm-6">
              <p className="mb-0">
                <i className="fa fa-arrow-right text-primary me-2" />
                Reliable City Taxi Services
              </p>
            </div>
            <div className="col-sm-6">
              <p className="mb-0">
                <i className="fa fa-arrow-right text-primary me-2" />
                Hassle-Free Airport Transfers
              </p>
            </div>
            <div className="col-sm-6">
              <p className="mb-0">
                <i className="fa fa-arrow-right text-primary me-2" />Customizable Tour Packages
              </p>
            </div>
            <div className="col-sm-6">
              <p className="mb-0">
                <i className="fa fa-arrow-right text-primary me-2" />
                Spacious Tempo Travellers
              </p>
            </div>
            <div className="col-sm-6">
              <p className="mb-0">
                <i className="fa fa-arrow-right text-primary me-2" />
                24/7 Customer Support
              </p>
            </div>
            <div className="col-sm-6">
              <p className="mb-0">
                <i className="fa fa-arrow-right text-primary me-2" />
                Professional and Experienced Drivers
              </p>
            </div>
          </div>
          {/* <a className="btn btn-primary py-3 px-5 mt-2" href="">
            Read More
          </a> */}
        </div>
      </div>
    </div>
  </div>
  )
}

export default About